import { api } from "../../lib";

export interface ExternalInstitution {
  id: string;
  name: string;
  shortName: string | null;
  address: string | null;
  city: string | null;
  state: string | null;
  zipCode: string | null;
  phone: string | null;
  fax: string | null;
  email: string | null;
  contactName: string | null;
  specialties: string | null;
  averageTurnaroundDays: number | null;
  isPreconfigured: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateExternalInstitutionInput {
  name: string;
  shortName?: string;
  address?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  phone?: string;
  fax?: string;
  email?: string;
  contactName?: string;
  specialties?: string;
  averageTurnaroundDays?: number;
  isActive?: boolean;
}

export interface UpdateExternalInstitutionInput
  extends Partial<CreateExternalInstitutionInput> {
  id: string;
}

export const externalInstitutionsService = {
  getAll: async () => {
    return api.get<ExternalInstitution[]>("/admin/external-institutions");
  },

  getActive: async () => {
    return api.get<ExternalInstitution[]>(
      "/admin/external-institutions/active"
    );
  },

  getById: async (id: string) => {
    return api.get<ExternalInstitution>(`/admin/external-institutions/${id}`);
  },

  create: async (input: CreateExternalInstitutionInput) => {
    return api.post<ExternalInstitution>("/admin/external-institutions", input);
  },

  update: async (input: UpdateExternalInstitutionInput) => {
    const { id, ...updates } = input;
    return api.put<ExternalInstitution>(
      `/admin/external-institutions/${id}`,
      updates
    );
  },

  toggleActive: async (id: string, isActive: boolean) => {
    return api.patch<ExternalInstitution>(
      `/admin/external-institutions/${id}/toggle-active`,
      { isActive }
    );
  },
};
